import styled from "@emotion/styled";

import { fontPlayfairDisplay, setLineClamp, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const Headline = styled.div`
  margin-block-start: 20px;
  padding-inline: 20px;

  color: #222222;
  font-weight: 400;
  font-size: 24px;
  font-family: ${fontPlayfairDisplay};
  font-style: normal;
  line-height: 30px;

  ${setLineClamp(4, "26px")}

  ${theme.breakpoints.up("tablet")} {
    padding-inline: 0;

    font-size: 20px;
    line-height: 26px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    ${setLineClamp(3, "30px")}
    font-size: 24px;
  }
`;
